import { useEffect } from "react";
import {
  callAPIInterface,
  getCurrencyAmount,
  lightningLabel,
} from "../components/constants";
import { lnurl, sats } from "../components/messages";

function useBalanceAndPaymentMethods({
  currency,
  data,
  isLightningMethod,
  isLnUrlMethodSend,
  payViaMethods,
  setBalanceData,
  setBalance,
  setPaymentMethods,
}) {
  const getPaymentMethods = (balanceData) => {
    const withdrawMethod =
      data?.withdraw_method === lnurl ? lightningLabel : data?.withdraw_method;

    const paymentMethodsObj = payViaMethods[withdrawMethod].map((method) => {
      let paymentMethodObj = method;
      const balance = balanceData?.find(
        (balance) => balance.target_currency === method.name
      )?.amount;
      paymentMethodObj.balance = balance || 0;
      return paymentMethodObj;
    });

    const isOnlySatsAllowed =
      (isLightningMethod && data?.amount === 0) ||
      (isLnUrlMethodSend && data?.min_sendable === data?.max_sendable);

    if (isOnlySatsAllowed) {
      let lightningPaymentMethods = paymentMethodsObj.filter(
        (method) => method.name === sats
      );
      setPaymentMethods(lightningPaymentMethods);
    } else {
      setPaymentMethods(paymentMethodsObj);
    }
  };

  const getBalance = () => {
    callAPIInterface("GET", `/balances`)
      .then((res) => {
        setBalanceData(res?.available);
        const targetedBalance = res?.available?.find(
          (bal) => bal.target_currency === currency
        );
        getPaymentMethods(res?.available);
        setBalance(getCurrencyAmount(targetedBalance?.amount, currency) || 0);
      })
      .catch((_err) => {});
  };

  useEffect(() => {
    getBalance();
  }, []);
}

export default useBalanceAndPaymentMethods;
